import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface PaginationSkeletonProps {
    /** 1-based page number we are navigating to. */
    currentPage: number
}

/**
 * Skeleton for pagination while a new results page is loading.
 */
export default function PaginationSkeleton({ currentPage }: PaginationSkeletonProps) {
    return (
        <nav
            aria-label="Policy Library Pagination"
            className="policy-library-listing-pagination"
            aria-busy="true"
        >
            <ul className="pagination">
                <li>
                    <Skeleton width={40} height={40} />
                </li>
                <li>
                    <span className="page-numbers currentpage" aria-current="page">
                        Page {currentPage}
                    </span>
                </li>
                <li>
                    <Skeleton width={40} height={40} />
                </li>
            </ul>
        </nav>
    );
}
